import BusinessTripCalculator from './BusinessTripCalculator';

export default BusinessTripCalculator;
